import React from 'react';

export default function FwCalendarIcon({ color = 'currentColor', fontSize = '16px' }) {
  return (
    <>
      <i className='far fa-calendar-alt' style={{ color, fontSize: fontSize }}></i>
    </>
  );
}
